import React from 'react';

import { observer } from 'mobx-react';
import { Button, DropdownMenu, DropdownMenuItem } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { useMonitoringTranslations } from '@bringg-frontend/monitoring';
import classNames from 'classnames';

import useOrderExplorerTranslations from 'bringg-web/features/monitoring/order-explorer/use-order-explorer-translations';
import { useSelectedStore } from '../../hooks/use-selected-store';

import styles from './main-column-header.module.scss';

interface MainColumnHeaderProps {
	totalViewItems: number;
	onEyeIconClick(): void;
	shouldShowUnselect?: boolean;
	bulkActionItems: DropdownMenuItem[];
	onSelect?: () => void;
}

const MainColumnHeader = ({
	totalViewItems,
	onEyeIconClick,
	// bulkActionItems,
	// onSelect,
	shouldShowUnselect
}: MainColumnHeaderProps) => {
	const { unselectAll } = useOrderExplorerTranslations();
	// const { bulkActions } = useMonitoringTranslations();
	const {
		store: { total: totalSelectedItems, clearSelectedTasks }
	} = useSelectedStore();
	const isInView = totalViewItems > 0;

	return (
		<div className={styles.mainColumnHeader} data-test-id="main-column-header">
			{shouldShowUnselect && (
				<div>
					<Button
						type="ghost"
						disabled={!isInView}
						onClick={onEyeIconClick}
						className={styles.eye}
						data-test-id="remove-from-view"
					>
						<BringgIcon
							iconName={isInView ? BringgFontIcons.Eye : BringgFontIcons.EyeOff}
							className={classNames({ [styles.hide]: !isInView })}
							data-test-id="view-all-eye-icon"
						/>
					</Button>

					{totalSelectedItems > 0 && (
						<Button className={styles.unselectAll} onClick={clearSelectedTasks} type="link">
							{unselectAll}
						</Button>
					)}
				</div>
			)}
			{/* <div className={styles.bulkActions}>
				<DropdownMenu
					items={bulkActionItems}
					placement="bottom-start"
					trigger={['click']}
					onMenuSelect={onSelect}
					noArrow
				>
					<Button type="link" size="small" aria-label="bulk-action-menu-button">
						{bulkActions}
						<BringgIcon iconName={BringgFontIcons.Chevron} />
					</Button>
				</DropdownMenu>
			</div> */}
		</div>
	);
};

export default observer(MainColumnHeader);
